/**
 * Created by Mikhail Menshenin on 28.10.2025
 */

GameBase.prototype.updateStats = function (options) {
    if (this.outcome !== GameBase.OUTCOME_UNKNOWN) {
        return;
    }

    if (!this.stats) {
        this.stats = {};
    }

    for (const key in options) {
        const value = options[key];
        this.stats[key] = value;
    }

    this.trigger("updateStats");
};
